<script setup>

const props = defineProps({
    title: String,
    content: String,
})

</script>

<template>

    <section class="title-text-section">
        <div class="main-content">
            <h2 class="text-section__title">{{ title }} </h2>
            <div v-if="content" class="text-section__content" v-html="content"></div>
        </div>        
    </section>

</template>

<style lang="scss" scoped>
.title-text-section {
    width: 100%;    
    max-width: 1350px;
    margin: 0 auto; 

    & .main-content{
       display: grid;
        grid-template-columns:  1fr;
        width: 100%;
        gap: 80px;
        padding: 200px 0 0;
        align-items: start;
        justify-content: center;
    }


    & .text-section__content {
        color: $white;
        font-size: 17px;
        letter-spacing: -.7px;
    }

    & .text-section__image {
        width: 100%;
        max-width: 900px;
        height: auto;
        margin: 70px auto;

    }

    @media screen and (min-width: 767px) {
       & .main-content{
            grid-template-columns: minmax(500px, 1fr) 1fr;
            padding: 200px 30px 0;
       }
    }
}

</style>